import {
  Box,
  Grid,
  IconButton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { Down, Left, Time } from "assets/Icon";

import BackButton from "components/BackButton";
import CoinDrawerList from "components/CoinDrawerList";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export function MobileDepositHeader({ coinList, selectedCoin }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const { watch } = useFormContext();
  const isDigital = watch("isDigital");

  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <GridHeader item xs={12}>
      <BoxCoin>
        <Box>
          <IconButton onClick={() => setOpenDrawer(true)}>
            <Down color={theme.palette.text.main} />
            <Typography variant="h6">{selectedCoin?.name}</Typography>
          </IconButton>

          <CoinDrawerList
            onOpen={() => setOpenDrawer(true)}
            onClose={() => setOpenDrawer(false)}
            open={openDrawer}
            onCoinClick={(coin) => navigate(`/deposit/${coin?.id}`)}
            coinList={coinList?.lisCoin}
            isDigital={isDigital}
          />
        </Box>

        <IconButton
          aria-label="history"
          size="small"
          onClick={() => {
            navigate("/history/spot?sideId=1");
          }}
        >
          <Time color={theme.palette.secondary.main} />
        </IconButton>
      </BoxCoin>

      <BackButton
        text="Deposit"
        icon={<Left color={theme.palette.text.main} />}
        to="/wallet/spot"
      />
    </GridHeader>
  );
}

const GridHeader = styled(Grid)(() => ({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  flexDirection: "row-reverse",
  alignItems: "center",
}));

const BoxCoin = styled(Grid)(({ theme }) => ({
  display: "flex",
  ".MuiBox-root": {
    ".MuiButtonBase-root": {
      padding: theme.spacing(1, 1.5),
      backgroundColor: theme.palette.modules.input,
      borderRadius: "10px",
      color: theme.palette.text.main,
      marginRight: theme.spacing(1.5),
      svg: {
        width: "30px",
        paddingRight: theme.spacing(1.5),
      },
    },
  },
  ".MuiButtonBase-root": {
    color: theme.palette.secondary.main,
    fontSize: "20px",
  },
}));

export default MobileDepositHeader;
